import { render, staticRenderFns } from "./outFrame.vue?vue&type=template&id=19395cc7&scoped=true"
import script from "./outFrame.vue?vue&type=script&lang=js"
export * from "./outFrame.vue?vue&type=script&lang=js"
import style0 from "./outFrame.vue?vue&type=style&index=0&id=19395cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19395cc7",
  null
  
)

export default component.exports